import { PatientProviderRowWithProvider } from "#/api/patientProvider.type";
import { useQuery } from "@tanstack/react-query";
import { getPatientProviders } from "../api/patientProviders.api";
import { useUserDetails } from "./useUserDetails";

function useLoadProviders(userId?: string) {
  const { userDetails } = useUserDetails();

  const {
    data: providers = [],
    isLoading,
    error,
  } = useQuery<PatientProviderRowWithProvider[]>({
    queryKey: ["providers", userId || userDetails?.id],
    queryFn: () => getPatientProviders(userId as string),
    enabled: !!userId || !!userDetails?.id,
  });

  return { providers, isLoading, error };
}

export default useLoadProviders;
